var AbstractViewModel = require("./AbstractViewModel")
var CallAheadWS = require("../ws/CallAheadWS")
const LeaveWS = require("../ws/LeaveWS");

function CheckInServicedViewModel(parent) {
  var self = this;

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's obcervable-bound variables
  AbstractViewModel.apply(this, arguments);

  // Convenience hook to the associated interface element
  self.locationId = ko.observable(null);
  self.notes = ko.observable(null);
  self.queueIds = [];
  self.sessionId = null;


	/**
	 * Hides the dialogue
	 *
	 * @method close
	 * @return none
	 */
  self.close = function () {
    self.parent.showCheckInServiced(false);
  };


	/**
	 * Handles button click
	 *
	 * @method no
	 * @param {Object} data
	 * @param {Event} evt
	 * @return none
	 */
  self.no = function (data, evt) {
    self.updateNotes();
    self.parent.doEndServiceTransactionWS();
    self.close();
  };


	/**
	 * Handles button click
	 *
	 * @method noAndRemove
	 * @param {Object} data
	 * @param {Event} evt
	 * @return none
	 */
  self.noAndRemove = function (data, evt) {
    const leaveWS = new LeaveWS(self.parent);

    self.queueIds.forEach(function (queueId) {
      // leaveWS.clearParams();
      // leaveWS.setAttribute('src', '/qless/api/v1/employee/queue/' + id + '/leave');
      // leaveWS.addParam('sessionId', self.sessionId);
      // leaveWS.doRequest();
      leaveWS.leaveQueue(queueId, self.sessionId);
    });

    self.no();
  };


	/**
	 * Sets params and calls the interface to be displayed
	 *
	 * @method open
	 * @param {String} customerName
	 * @param {String} sessionId
	 * @param {Array} queueIds
	 * @param {Number} locationId
	 * @return
	 */
  self.open = function (customerName, sessionId, queueIds, locationId) {
    self.sessionId = sessionId;
    self.queueIds = queueIds;
    self.locationId(locationId);

    self.parent.showBarcodeScanner(false);

    self.parent.showCheckInServiced(true);
  };


	/**
	 * Determines if the dialog panel needs to be displayed to the user
	 *
	 * @method openIfNecessary
	 * @return none
	 */
  self.openIfNecessary = function () {
    var consumer = null
    var locationId = null
    var name = null
    var otherQueueIds = []
    var trans = null

    self.reset();

    if (self.parent.currentlyServicingSuccessors() > 0) {
      if (!self.parent.disableCheckInServicedDialog()) {
        self.open(null, self.parent.currentlyServicing().spot.sessionId, self.parent.currentlyServicingSuccessors(), null);
        return true;
      }

      // self.parent.currentlyServicingSuccessors( [] );
    }
    else if (self.parent.currentlyServicing().length > 0 && self.parent.endServiceSessionId() != null) {
      trans = self.parent.currentlyServicing.filter(function (t) {
        return t.sessionId === self.parent.endServiceSessionId();
      })

      if (trans.length > 0) {
        consumer = trans[0];

        self.parent.queues().forEach(function (queue) {
          var spots = queue.spots();

          spots.forEach(function (spot) {
            if (name == null || locationId == null) {

              if (consumer.spot.sessionId === spot.sessionId && spot.callAhead) {

                if (queue.predecessorQueueIds.length > 0) {

                  otherQueueIds.push(queue.id);

                  if (name == null) {
                    name = spot.privateName();
                  }

                  if (locationId == null) {
                    locationId = queue.locationId;
                  }
                }
              }
            }
          })
        });

        if (otherQueueIds.length > 0) {

          if (!self.parent.disableCheckInServicedDialog()) {
            self.open(null, consumer.spot.sessionId, otherQueueIds, locationId);
            return true;
          }
        }

      }
    }

    return false;
  };


	/**
	 * Resets the view model to a default state
	 *
	 * @method reset
	 * @returns none
	 */
  self.reset = function () {
    self.locationId(null);
    self.notes(null);
    self.queueIds = [];
    self.sessionId = null;
  };


	/**
	 * Presents the title for the dialog interface
	 *
	 * @method title
	 * @returns {String}
	 */
  self.title = ko.computed(function () {
    var key = self.locationId() == null ? 'serviced.eligible' : 'serviced.checkIn'
    var str = self.parent.messagesWS.get(key)
    var name = null
    var trans = null

    if (self.parent.currentlyServicing().length > 0 && self.parent.endServiceSessionId() != null) {
      trans = self.parent.currentlyServicing().filter(function (t) {
        return t.sessionId === self.parent.endServiceSessionId();
      })

      name = (trans.length > 0) ? trans[0].spot.privateName() : null;

      str = str.replace(/\{0\}/, name);
    }

    return str;
  });


	/**
	 * Submits the notes to the API service
	 *
	 * @method updateNotes
	 * @param {Object} data
	 * @param {Event} evt
	 * @return none
	 */
  self.updateNotes = function () {
    var notes = self.notes();

    if (notes) {
      self.parent.updateConsumerInfoWS.endpoint('src', '/qless/api/v1/employee/queue/' + self.queueIds[0] + '/consumer');
      self.parent.updateConsumerInfoWS.clearParams();
      self.parent.updateConsumerInfoWS.addParam('sessionId', self.sessionId);
      self.parent.updateConsumerInfoWS.addParam('notes', notes);
      self.parent.updateConsumerInfoWS.addParam('queueId', self.queueIds[0]);
      self.parent.updateConsumerInfoWS.doRequest();
    }

    self.reset();
  };


	/**
	 * Handles button click
	 *
	 * @method yes
	 * @param {Object} data
	 * @param {Event} evt
	 * @return none
	 */
  self.yes = function (data, evt) {
    var ws = new CallAheadWS();

    if (self.locationId() != null) {
      ws.endpoint('/qless/api/v1/employee/location/' + self.locationId() + '/callAhead');
    }
    else {
      ws.endpoint('/qless/api/v1/employee/queues/' + self.queueIds.join(',') + '/callAhead');
    }

    ws.addParam('sessionId', self.sessionId);

    self.updateNotes();

    self.parent.doEndServiceTransactionWS();

    ws.doRequest();
    self.close();
  };

  // Expose the object as it's own API
  return self;
};

module.exports = CheckInServicedViewModel
